export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7451.93bb6622.jpg";